import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const Th = React.forwardRef((props, ref) => {
    const { children, className, asElement: Component, ...rest } = props

    const thClass = classNames(Component !== '' && 'bg-gray-100 px-4 py-3 font-medium text-left text-gray-600', className)

    return (
        <Component className={thClass} {...rest} ref={ref}>
            {children}
        </Component>
    )
})

Th.propTypes = {
    asElement: PropTypes.string,
}

Th.defaultProps = {
    asElement: 'th',
}

export default Th
